module.exports = __webpack_public_path__ + "img/xiepengyu.8a26183c.jpg";